import { FeaturedImageFragment } from '@/fragments/FeaturedImage'
import { GravityFormsFragment } from '@/fragments/GravityForms'
import { gql } from '@apollo/client'

export const variables = ({ databaseId }, ctx) => {
  return {
    databaseId,
    asPreview: ctx?.asPreview
  }
}

export const query = gql`
  ${FeaturedImageFragment}
  ${GravityFormsFragment}
  query GetPageData($databaseId: ID!, $asPreview: Boolean = false) {
    page(id: $databaseId, idType: DATABASE_ID, asPreview: $asPreview) {
      title
      seo {
        metaDesc
        title
      }
      ...FeaturedImageFragment
      innerHeroFields {
        content
        eyebrowText
        fieldGroupName
        includeForm
        title
      }
    }
    contactForm: gfForm(id: 1, idType: DATABASE_ID) {
      ...GravityFormsFragment
    }
  }
`
